import React, { useState } from "react";

import Edit from "Resources/ImagesNew/IconTable/iconEdit.png";
import { ModalSua } from "./ModalSua";

export const BtnSua = ({ item, setFilterCookie, index }) => {
  const [isOpenModalSua, setOpenModalSua] = useState(false);

  const openModalSua = (e) => {
    e.preventDefault();

    if (setFilterCookie) {
      setFilterCookie();
    }

    setOpenModalSua(true);
  };

  const closeModalSua = () => {
    setOpenModalSua(false);
  };

  return (
    <>
      <a
        id={"btnSuaDonHang" + index}
        href={() => false}
        className="iconTable-Main"
        onClick={openModalSua}
      >
        <img src={Edit} title="Sửa" alt="" />
      </a>

      {isOpenModalSua && <ModalSua CloseModalSua={closeModalSua} item={item} />}
    </>
  );
};
